var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidentsToplevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6378 21.1657L16.7572 21.1657L17.0242 21.1665C19.0648 21.1782 23.7282 21.3566 23.7282 24.0929C23.7282 26.8113 19.2274 26.9885 17.056 27.0001L16.2515 27.0001C14.2107 26.9885 9.54639 26.8102 9.54639 24.0774C9.54639 21.3556 14.2107 21.1781 16.2515 21.1665L16.5185 21.1657C16.5599 21.1657 16.5997 21.1657 16.6378 21.1657ZM16.6378 22.5383C14.1264 22.5383 11.1319 22.8055 11.1319 24.0774C11.1319 25.3205 13.9476 25.6111 16.4083 25.6276L16.6378 25.6284C19.1493 25.6284 22.1427 25.3621 22.1427 24.0929C22.1427 22.8082 19.1493 22.5383 16.6378 22.5383ZM16.6378 11.6365C19.3015 11.6365 21.4673 13.5123 21.4673 15.8173C21.4673 18.1223 19.3015 19.9981 16.6378 19.9981H16.6093C15.3197 19.9945 14.1116 19.5571 13.2068 18.7665C12.2999 17.9768 11.8041 16.9282 11.8094 15.8145C11.8094 13.5123 13.9752 11.6365 16.6378 11.6365ZM16.6378 13.009C14.8494 13.009 13.3949 14.269 13.3949 15.8173C13.3918 16.5676 13.7237 17.2695 14.3314 17.7993C14.9392 18.3291 15.7489 18.6228 16.6114 18.6256L16.6378 19.3118V18.6256C18.4263 18.6256 19.8818 17.3665 19.8818 15.8173C19.8818 14.269 18.4263 13.009 16.6378 13.009Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5377 9.61814V7.5379V3.37742C15.5377 2.06441 14.8281 1 13.9528 1H2.85814C1.9828 1 1.27319 2.06441 1.27319 3.37742V20.0193C1.27319 21.3324 1.9828 22.3968 2.85814 22.3968H8.40545",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3691 4.9624H9.9917V9.71724H12.3691V4.9624Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82346 12.887H4.44604V18.4343H6.82346V12.887Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82346 4.9624H4.44604V9.71724H6.82346V4.9624Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentsToplevel);
export default __webpack_public_path__ + "static/media/residents-toplevel.e6d3f6cfba8a154aad94c8492c135b23.svg";
export { ForwardRef as ReactComponent };